import axios from 'axios';
import { COUNTRIES_API_KEY, COUNTRIES_BASE_URL, KEY_ACCESS_TOKEN, KEY_AZURE_TOKEN, KEY_CONFIG_URL, KEY_REFRESH_TOKEN, REFRESH_URL } from '../Constants/constant';
let appConfig;
export let axiosInstance;
const configUrl = KEY_CONFIG_URL;

export const getAxiosInstance = (data) => {
  // appConfig = data[0]?.config;
  appConfig = data?.config;
  console.log(data, 'config');
  axiosInstance = axios.create({
    baseURL: 'https://pichainlabs-onboarding-api.ken42.com',
    timeout: 20000,
  });

  axiosInstance.interceptors.request.use((req) => {
    const token = localStorage.getItem(KEY_AZURE_TOKEN);
    req.headers['access-token'] = localStorage.getItem(KEY_ACCESS_TOKEN);
    req.headers.Authorization = `Bearer ${token}`;
    return req;
  });

  //Response interceptor for API calls
  axiosInstance.interceptors.response.use(
    (resp) => {
      return resp;
    },
    async function (error) {
      console.log('ApiService: Interceptor: ', error);
      if (!error.response?.config && error.response?.status !== 401) {
        return error;
      }
      return axios({
        method: 'get',
        baseURL: `${appConfig.tokenUrl}`,
      }).then(async (response) => {
        if (localStorage.refresh_token && (error.response.status === 402 || error.response.status === 502 || error.response.status === 500)) {
          const url = REFRESH_URL;
          try {
            const res = await axios.post(
              url,
              {
                refreshToken: localStorage.refresh_token,
              },
              {
                headers: {
                  Authorization: `Bearer ${localStorage.azure_token}`,
                  Accept: 'application/json',
                  'Content-Type': 'application/json',
                },
              }
            );
            localStorage.setItem(KEY_ACCESS_TOKEN, res?.data?.accessToken?.token);
            localStorage.setItem(KEY_REFRESH_TOKEN, res?.data?.refreshToken?.token);
            localStorage.setItem(KEY_AZURE_TOKEN, response.data.access_token);
            error.response.config.headers['Authorization'] = `Bearer ${response.data.access_token}`;
            error.response.config.headers['access-token'] = res.data.accessToken.token;
            return axios(error.response.config);
          } catch (err) {
            // localStorage.clear();
            // window.location.reload();
          }
        } else {
          localStorage.setItem(KEY_AZURE_TOKEN, response.data.access_token);
          error.response.config.headers['Authorization'] = `Bearer ${response.data.access_token}`;
          return axios(error.response.config);
        }
      });
    }
  );
};

getAxiosInstance();

export const getConfig = async () => {
  // const path = 'apply-stage-turbostart.ken42.com';
  const path = '6639d516da1c76001a908c70';
  const res = await axios.get(`${configUrl}/${path}`);
  return res && res.data ? res.data : null;
};

export const hdfcPaymentIntegartion = async (data) => {
  try {
    const path = `hdfc/payments/initiate`;
    const response = await axiosInstance.post(`${path}`, data);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const hdfcPaymentIntegartionv2 = async (data) => {
  const path = 'hdfc/payments/initiate';
  const res = axiosInstance.post(path, data);
  return res;
};

export const getAllPrograms = async (applicantId) => {
  const path = `api/salesforce?endpoint=${encodeURIComponent(`services/apexrest/application/retrieve/forms`)}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const getFormByFormId = async (formId) => {
  const path = `api/salesforce?endpoint=${encodeURIComponent(`services/apexrest/application/retrieve/form?formid=${formId}`)}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const getSendOTPWithoutContact = async (email) => {
  const path = `api/salesforce?endpoint=${encodeURIComponent(`services/apexrest/OneTimePassword/send?email=${email}`)}`;
  const res = await axiosInstance.post(`${path}`);
  return res && res.data ? res.data : null;
};

export const postVerifyOTPWithoutContact = async (email, otp) => {
  const path = `api/salesforce?endpoint=${encodeURIComponent(`services/apexrest/OneTimePassword/verify?contact=${email}&otpEnteredEmail=${otp}`)}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const getApplicationsByApplicantId = async (applicantid) => {
  const path = `api/salesforce?endpoint=${encodeURIComponent(`services/apexrest/application/retrieve/applications?applicantid=${applicantid}`)}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const getApplicationByApplicationId = async (applicationId) => {
  const path = `api/salesforce?endpoint=${encodeURIComponent(`services/apexrest/application/retrieve/application?applicationid=${applicationId}`)}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const createUpdateApplication = async (data) => {
  const path = `api/application/save`;
  const res = await axiosInstance.post(`${path}`, data);
  return res && res.data;
};

export const deleteApplicationRecords = async (data) => {
  const delData = { data: data };
  const path = `portla/delete`;
  const res = await axiosInstance.delete(`${path}`, delData);
  return res && res.data ? res.data : null;
};

/**
 *
 *
 * Invalid URL
 *
 *
 */

export const getDocuments = async (applicantId) => {
  const path = `api/salesforce?endpoint=${encodeURIComponent(`services/apexrest/application/retrieve/documentstatus?applicantid=${applicantId}`)}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const createDocuments = async (data) => {
  const path = `signup`;
  const res = await axiosInstance.post(`${path}`, data);
  return res && res.data ? res.data : null;
};

export const getNotifications = async (applicantId) => {
  const path = `notificationbyapplicant?applicantid=${applicantId}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const getImportantDates = async () => {
  const path = `api/salesforce?endpoint=services/apexrest/portal/retrieve/importantdates`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const getFeeDetails = async (data) => {
  const path = `retrivefeedetails?applicantid=${data}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const postFeeCoupon = async (data) => {
  const path = `api/salesforce?endpoint=/services/apexrest/portalfee/validatecoupon`;
  const res = await axiosInstance.post(`${path}`, data);
  return res && res.data ? res.data : null;
};

export const getOfferLetter = async (data) => {
  const path = `offerletter?applicantid=${data}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const postInitatePayment = async (data) => {
  const path = `payments/flywire/initiate`;
  const res = await axiosInstance.post(`${path}`, data);
  return res && res.data ? res.data : null;
};

export const getFeeReceipt = async (data) => {
  const path = `api/salesforce?endpoint=services/apexrest/portalfee/retrieve/receipt?transactionid=${data}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const getQuestionare = async (data) => {
  const path = `api/salesforce?endpoint=services/apexrest/portal/retrieve/questionarie?contactid=${data}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const postQuestionare = async (data) => {
  const path = `api/salesforce?endpoint=services/apexrest/portal/retrieve/save`;
  const res = await axiosInstance.post(`${path}`, data);
  return res && res.data ? res.data : null;
};

export const getTransactionDetailsByTransactionId = async (data) => {
  const path = `api/salesforce?endpoint=services/apexrest/portalfee/retrieve/transaction?paymentid=${data}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const postAppliedCouponCode = async (data) => {
  const path = `api/salesforce?endpoint=services/apexrest/AppliedCouponCodeAPI`;
  const res = await axiosInstance.post(`${path}`, data);
  return res && res.data ? res.data : null;
};
export const postUploadDocument = async (data) => {
  const path = `/uploadDocument`;
  const res = await axiosInstance.post(`${path}`, data);
  return res && res.data ? res.data : null;
};

export const getRenderingDetails = async (data) => {
  const path = `renderingdetails?applicantid=${data}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

// Not Done
export const getApplicantByEmail = async (email) => {
  const path = `verify/email?email=${email}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const getDocumentsViaRecordId = async (id) => {
  const path = `api/salesforce?endpoint=${encodeURIComponent(`services/apexrest/application/retrieve/document?docid=${id}`)}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const getOfferletterViaApplicationId = async (id) => {
  const path = `offerletterbyapplication?applicationid=${id}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const getInterviewSlotsViaApplicationId = async (id) => {
  const path = `api/salesforce?endpoint=services/apexrest/interview/retrieve/slottimings?applicationid=${id}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

// Not Done
export const postSaveSlots = async (data) => {
  const path = `api/salesforce?endpoint=services/apexrest/interview/save/slot`;
  const res = await axiosInstance.post(`${path}`, data);
  return res && res.data ? res.data : null;
};

// Not Done
export const postSavePreferences = async (data) => {
  const path = `save/preference`;
  const res = await axiosInstance.post(`${path}`, data);
  return res && res.data ? res.data : null;
};

// Not Done
export const postInterviewSlots = async (data) => {
  const path = `api/salesforce?endpoint=services/apexrest/interview/save/slot`;
  const res = await axiosInstance.post(`${path}`, data);
  return res && res.data ? res.data : null;
};

// Not Done
export const postInterviewStudentRequestedSlots = async (data) => {
  const path = `api/salesforce?endpoint=services/apexrest/interview/save/studentRequestedSlot`;
  const res = await axiosInstance.post(`${path}`, data);
  return res && res.data ? res.data : null;
};

export const getOldApplicationData = async (id) => {
  const path = `api/salesforce?endpoint=services/apexrest/portal/retrieve/oldApplication?applicationid=${id}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

export const postManualFeePayment = async (data) => {
  const path = `manualfeepayment`;
  const res = await axiosInstance.post(`${path}`, data);
  return res && res.data ? res.data : null;
};

export const postSignUpWithoutContact = async (email, phone) => {
  const path = `onetimepassword?email=${email}&phone=${phone}`;
  const res = await axiosInstance.post(`${path}`, {});
  return res && res.data ? res.data : null;
};

export const getVerfiyOTPWithoutContact = async (email, otp) => {
  const path = `verifyonetimepassword?contact=${email}&otp=${otp}`;
  const res = await axiosInstance.get(`${path}`);
  return res && res.data ? res.data : null;
};

const axiosinstancecountries = axios.create({
  baseURL: COUNTRIES_BASE_URL,
  headers: {
    accept: 'application/json',
    'X-CSCAPI-KEY': COUNTRIES_API_KEY,
  },
});

export const getCountries = async () => {
  const path = 'v1/countries';
  const res = await axiosinstancecountries.get(path);
  return res && res.data ? res.data : null;
};

export const getStates = async (iso) => {
  const path = `v1/countries/${iso}/states`;
  const res = await axiosinstancecountries.get(path);
  return res && res.data ? res.data : null;
};

export const getCities = async (iso, siso) => {
  const path = `v1/countries/${iso}/states/${siso}/cities`;
  const res = await axiosinstancecountries.get(path);
  return res && res.data ? res.data : null;
};

// PIChain

export const ocrAndVerifyAadhar = async (body) => {
  const path = `https://api.pichainlabs.com/v3/extract_and_verify`;
  const res = await axios.post(`${path}`, body, {
    headers: {
      Apikey: 'WWkZnSzOd8cquxnoxwLn1atF7deCNukc',
      'Org-Id': '601822a9003284bfa7903346',
    },
    timeout: 20000,
  });
  return res && res.data ? res.data : null;
};

export const verifyBankAccount = async (body) => {
  const path = `https://api.pichainlabs.com/v1/account_verification`;
  const res = await axios.post(`${path}`, body, {
    headers: {
      Apikey: 'WWkZnSzOd8cquxnoxwLn1atF7deCNukc',
      'Org-Id': '601822a9003284bfa7903346',
    },
    timeout: 20000,
  });
  return res && res.data ? res.data : null;
};

export const initiateFaceMatch = async (body) => {
  const path = `https://api.pichainlabs.com/pms/v1/face_match/onboard_initiate`;
  const res = await axios.post(`${path}`, body, {
    headers: {
      Apikey: 'WWkZnSzOd8cquxnoxwLn1atF7deCNukc',
      'Org-Id': '641846538ad0432c9aea728a',
      'Content-Type': 'application/json',
    },
    timeout: 20000,
  });
  return res && res.data ? res.data : null;
};

export const verifyFaceMatch = async (body) => {
  const path = `https://api.pichainlabs.com/pms/v1/face_match/onboard_status`;
  const res = await axios.post(`${path}`, body, {
    headers: {
      Apikey: 'WWkZnSzOd8cquxnoxwLn1atF7deCNukc',
      'Org-Id': '641846538ad0432c9aea728a',
      'Content-Type': 'application/json',
    },
    timeout: 20000,
  });
  return res && res.data ? res.data : null;
};

export const eSignInitateContract = async (body) => {
  const path = `https://api.pichainlabs.com/v1/onboard/initiate_contract`;
  const res = await axios.post(`${path}`, body, {
    headers: {
      Apikey: 'WWkZnSzOd8cquxnoxwLn1atF7deCNukc',
    },
    timeout: 20000,
  });
  return res && res.data ? res.data : null;
};

export const eSignStatus = async (refId) => {
  const path = `https://api.pichainlabs.com/v1/onboard/reference/5f4cb579227a5c41346d1390/${refId}`;
  const res = await axios.get(`${path}`, {
    headers: {
      Apikey: 'WWkZnSzOd8cquxnoxwLn1atF7deCNukc',
    },
    timeout: 20000,
  });
  return res && res.data ? res.data : null;
};

export const chequeOCR = async (body) => {
  const path = `https://api.pichainlabs.com/v3/classify_and_extract`;
  const res = await axios.post(`${path}`, body, {
    headers: {
      Apikey: 'WWkZnSzOd8cquxnoxwLn1atF7deCNukc',
      'Org-Id': '641846538ad0432c9aea728a',
      'Content-Type': 'application/json',
    },
    timeout: 20000,
  });
  return res && res.data ? res.data : null;
};
